export default "__VITE_ASSET__2750b194__"